import Link from "next/link";
import {
  FaArrowRight,
  FaRegCalendarAlt,
  FaEye,
} from "react-icons/fa";
import SafeImage from "@/components/SafeImage";

/**
 * Blog archive card.
 * Image source resolution order:
 *   1. absolute featured_image URL returned by the CMS (production)
 *   2. /img/blog/<thumbImg> path used by the static fallback JSON
 * If neither is present we render a neutral placeholder block so the
 * card layout never breaks.
 */
const BlogItemTwo = ({ blogData, slug, baseUrl }) => {
  const href = `/${baseUrl}/${slug}`;
  const imgSrc =
    blogData.featured_image ||
    (blogData.thumbImg ? `/img/blog/${blogData.thumbImg}` : "");
  const badge = blogData.type || (blogData.tag && blogData.tag[0]) || "";

  return (
    <article className="blog-card">
      <div className="blog-card__media" aria-hidden="true">
        {imgSrc ? (
          <SafeImage
            src={imgSrc}
            alt=""
            role="presentation"
            width={600}
            height={400}
            sizes="(max-width: 575px) 100vw, (max-width: 991px) 50vw, 33vw"
            loading="lazy"
            style={{ width: "100%", height: "auto" }}
          />
        ) : (
          <div className="blog-card__placeholder" />
        )}
        {badge ? (
          <span className="blog-card__badge">{badge}</span>
        ) : null}
      </div>

      <div className="blog-card__body">
        <div className="blog-card__meta">
          {blogData.date ? (
            <span className="blog-card__date">
              <FaRegCalendarAlt /> {blogData.date}
            </span>
          ) : null}
          {blogData.views ? (
            <span className="blog-card__views">
              <FaEye /> {blogData.views}
            </span>
          ) : null}
        </div>

        <h2 className="blog-card__title">
          <Link href={href}>{blogData.title}</Link>
        </h2>

        {blogData.shortDescription ? (
          <p className="blog-card__excerpt">{blogData.shortDescription}</p>
        ) : null}

        <Link href={href} className="blog-card__more">
          Read article: {blogData.title} <FaArrowRight aria-hidden />
        </Link>
      </div>
    </article>
  );
};

export default BlogItemTwo;
